
import { vxeGrid, customModal } from "@newview/ui";
import { BaseVue } from "@newview/base-web";
import { Component, Prop } from "vue-property-decorator";
import { WorkFlowTaskApi } from "@newview/basicdata-api";
import FlowStepRecord from "./FlowStepRecord.vue";
@Component({
  components: { vxeGrid, customModal, FlowStepRecord },
})
export default class ApprovalFlow extends BaseVue {
  workFlowTaskApi: WorkFlowTaskApi = new WorkFlowTaskApi();

  @Prop(String)
  taskType;

  @Prop(String)
  title; //slot区标题
  @Prop(String)
  signType; // 签字类型
  @Prop(String)
  flowIds; // 签字类型

  itemInfo: any = {};
  Status = "2,9";
  gridShow = true;
  approvalModal = false;
  backStep=0;
  approvalRow = {};
  activeApprovalRow: any = {};
  opinionData = "同意"; // 审批意见
  approvalType = "Pass";
  stepsList = []; // 步骤列表
  historyList: any = []; // 历史记录列表
  activeStepObj: any = {}; // 当前步骤
  isCustomUser = false; // 是否指定审批人
  examineUser = ""; // 指定的审批人Id
  examineUserName = ""; // 指定审批人姓名
  historyModal=false;
  rowData:any={}
  backList:any =[]
  ColConfig1 = [
    { key: "", colType: "seq", minWidth: 20 },
    { key: "taskName", title: "待审任务", minWidth: 260, align: "left" },
    {
      key: "status",
      title: "状态",
      align: "center",
      format: (row) => {
        return (
          '<span style="color:' +
          (row.status == 9 ? "#f00" : "#2979ff") +
          '">' +
          (row.status == 9 ? "驳回" : "待审批") +
          "</span>"
        );
      },
    },
  ];
  ColConfig2 = [
    { key: "", colType: "seq", minWidth: 20 },
    { key: "taskName", title: "待审任务", minWidth: 260, align: "left" },
    {
      key: "status",
      title: "状态",
      align: "center",
      format: () => {
        return '<span style="color: #ccc">已审批</span>';
      },
    },
  ];
  paginationSetting2 = {
    total: 0,
    pageSize: 15,
    pageChange: this.fetchGridData,
  };
  rowOperation = {
    width: 70,
    isEditBtn: false,
    isDelBtn: false,
    otherBtn: [
      {
        name: "审批",
        code: "-",
        dataOValid: (row) => {
          if (row.status == 9 && row.sort == 1) {
            return false;
          } else {
            return true;
          }
        },
        clickEvent: this.approvalEvent,
      },
      {
        name: "提交",
        code: "-",
        dataOValid: (row) => {
          if (row.status == 9 && row.sort == 1) {
            return true;
          } else {
            return false;
          }
        },
        clickEvent: this.approvalEvent2,
      },
    ],
  };
  gridData:any = [];

  mounted() {
    this.fetchGridData();
  }

  /**
   * 打开选择审批人弹窗
   */
  openCommonSel() {
    const that = this;
    this.commonSel.comSelUser({
      subSystemId: this.$globalData_Plms.subSysteminfor.id,
      type: 3,
      isMulit: false,
      selCallBack: function (param) {
        that.examineUserName = param[0].userName;
        that.examineUser = param[0].userId;
      },
    });
  }

  /**
   * 清空数据
   */
  clearData() {
    this.gridData = [];
    this.stepsList = [];
    this.historyList = [];
    this.activeApprovalRow = {};
    this.selectRow(null);
  }

  /**
   * 审批状态选择
   */
  selectStatus() {
    this.fetchGridData()
    let row:any={
      flowId:0,
      biid:0
    }
    this.selectRow(row);
    this.gridShow = false;
    setTimeout(() => {
      this.gridShow = true;
    }, 0);
   
  }

  /**
   * 表格行选择
   */
  async selectRow(row: any = null) {
    this.$emit("on-row-selected", row);
    if (row) {
      this.itemInfo.flowId = row.flowId;
      this.itemInfo.biid = row.biid;
      this.$nextTick(() => {
        (this.$refs["flowStepRecordRef"] as any).getStep(this.itemInfo);
      });
      await this.fetchHistoryList(row.flowId, row.biid);
      await this.fetchStepsList(row.flowId, row.biid);
      if (this.signType === "1") {
        this.fetchSignImg();
      }
      this.activeApprovalRow = row;
      console.log(row);
      this.loadStepIsCustomUser(row.flowId);
    }
  }

  /**
   * 加载待审批表格数据
   */
  async fetchGridData(pageIndex = 1) {
    let res:any;
    let userId = this.$globalData_Plms.localUser.id;
    if(this.Status=="3"){
      res = await this.workFlowTaskApi.getWorkFlowYetTask(
            userId,
            pageIndex,
            15,
              this.flowIds
          );
    }else{
      res = await this.workFlowTaskApi.getWorkFlowPendTask(
          userId,
          pageIndex,
          15,
              this.flowIds
        );
    }

    if (res.data.records.length > 0) {
      this.gridData = res.data.records;
      this.paginationSetting2.total = res.data.total;
      this.selectRow(this.gridData[0]); // 默认加载第一行
      this.loadStepIsCustomUser(this.gridData[0].flowId);
    } else {
      this.clearData();
      this.selectRow(); // 默认加载第一行
    }
  }
  //根据key对数组去重 
  deduplication(arr, key) {
    let res:any = []
    arr.forEach((item) => {
      let list:any = []
      res.forEach((resitem) => {
        list.push(resitem[key])
      })
      if (list.indexOf(item[key]) === -1) {
        res.push(item)
      }
    })
    return res
  }

  /**
   * 加载历史记录
   */
  async fetchHistoryList(flowId, biid) {
    this.historyList = [];
    let res = await this.workFlowTaskApi.getStepRecord(flowId, biid);
    if (res.code == 200) {
      if (res.data.length > 0) {
        for (const iterator of res.data) {
          if (iterator.details[0]) {
            this.historyList.push(iterator.details[0]);
          }
        }
      }
    }
  }

  /**
   * 加载签字
   */
  fetchSignImg() {
    // let _this = this;
    // if (this.stepsList.length > 0) {
    //   this.stepsList.forEach((item) => {
    //     if (item.NodeTypeName === "已审批") {
    //       this.userinforApi.getEntity(item.UserId).then((res) => {
    //         item.UserSignImg = res.result.Sign;
    //       });
    //     }
    //   });
    // }
  }
  /**
   * 查看历史审批记录
   */
  watchHistory(){
    this.historyModal=true;
  }

  /**
   * @description：审批提交
   */
  async submitApproval() {
    debugger
    if (this.approvalType === "Pass") {
      if (
        this.approvalType === "Pass" &&
        this.isCustomUser &&
        this.examineUser === ""
      ) {
        this.error("请选择审批人");
        return;
      }
      let para: any = {};
      para.wfId = this.activeApprovalRow.flowId;
      para.userId = this.$globalData_Plms.localUser.id;
      para.biid = this.activeApprovalRow.biid;
      para.workFlowTaskId = this.activeApprovalRow.id;
      para.opinion = this.opinionData;
      para.nextUserId = this.examineUser;
      let isEnd = 0;
      if (this.activeApprovalRow.wdtGuid === "[]") {
        isEnd = 1;
      }
     
      let res = await this.workFlowTaskApi.workFlowNext(para);
      if (res.code==200) {
        // 通过
        this.$emit("on-approve-pass",{isEnd});
        this.success("审批成功");
        this.approvalType = "Pass";
        this.opinionData = "同意";
        this.approvalModal = false;
        this.fetchGridData();
        this.$emit("on-approve",true);
      }
    }else{
      if(this.backList.length>0 &&this.backStep==0){
          this.error("请选择退回步骤！");
        return;
      }
      // 驳回操作
      let para: any = {};
      para.wfId = this.activeApprovalRow.flowId;
      para.userId = this.$globalData_Plms.localUser.id;
      para.biid = this.activeApprovalRow.biid;
      para.workFlowTaskId = this.activeApprovalRow.id;
      para.taskId = this.activeApprovalRow.id;
      para.opinion = this.opinionData;
      if(this.backStep!=0){
        para.rejectStepId = this.backStep;
      }
      let ifNotEnd= false;
      let isEnd = 0;
      if(this.backList.length>0){
        var endList = this.backList[this.backList.length-1]
        if(endList.id == this.backStep){
            ifNotEnd = true
        }
      }
      if (this.backList.length==0||ifNotEnd) {
        isEnd = 1;
      }
      let resData = await this.workFlowTaskApi.workFlowReject(para);
      if(resData.code==200){
          this.success("处理成功!");
          this.fetchGridData();
          this.$emit("on-approve-return",{isEnd});
          this.approvalModal = false;
          this.$emit("on-approve",true);
      }else{
          this.error("处理失败!");
          this.approvalModal = false;
      }


      
    }
  }

  /**
   * @description：加载流程步骤
   * @param {*} FlowId
   * @param {*} Id
   */
  async fetchStepsList(FlowId, Id) {
    console.log(FlowId, Id);
    // // 获取所有步骤
    // const res = this.parseApiResult(
    //   await this.BusinessworkflowtaskApi.getEntitiesDynamic(
    //     "*",
    //     "FlowId=" + FlowId + " AND BIId=" + Id,
    //     "Sort ASC"
    //   )
    // );
    // // 加载当前步骤
    // const res1 = this.parseApiResult(
    //   await this.BusinessworkflowtaskApi.getEntitiesDynamic(
    //     "*",
    //     "FlowId=" + FlowId + " AND BIId=" + Id + " AND Status IN (2,9)",
    //     "Sort ASC"
    //   )
    // );
    // if (res1.length > 0) {
    //   this.activeStepObj.NowStepNum = parseInt(res1[0].Sort) - 1;
    // } else {
    //   this.activeStepObj.NowStepNum = res.length + 1;
    // }
    // this.stepsList = this.Baselinq.from(res)
    //   .select((x) => {
    //     let approvalStep: any = this.Baselinq.from(
    //       this.historyList
    //     ).firstOrDefault((e) => e["WFSId"] == x["WFSId"]);
    //     return {
    //       NodeTypeName:
    //         x["Sort"] == 1
    //           ? "已提交"
    //           : x["Sort"] == this.activeStepObj.NowStepNum + 1
    //           ? "待审批"
    //           : x["Sort"] <= this.activeStepObj.NowStepNum
    //           ? "已审批"
    //           : "未审批",
    //       Id: x["Sort"],
    //       ProcessName: x["StepName"],
    //       UserId: approvalStep ? approvalStep.UId : 0,
    //       UserSignImg: "",
    //     };
    //   })
    //   .toArray();
  }

  /**
   * @description: 审批事件
   * @param {*} row
   * @return {*}
   */
  approvalEvent(row) {
    this.rowData = row;
    let list:any =this.gridData.filter(e=>e.id== row.id);
    let nextWorkFlowTask:any = list[0].nextWorkFlowTask;
    if(nextWorkFlowTask!=null&&nextWorkFlowTask.assignMode==2){
      // 选择下一步处理人
      this.isCustomUser = true;
    }
    this.approvalModal = true;
    this.examineUser = "";
    this.examineUserName = "";
    this.$emit("on-approve",false);
    
  }

  /**
   * @description: 提交事件
   * @param {*}
   * @return {*}
   */
  approvalEvent2() {
    this.$emit("on-submit");
  }

  async finishSubmit() {
    // await this.BusinessworkflowtaskApi["TaskPass"]({
    //   Id: this.activeApprovalRow.Id,
    //   Postil: "重新提交",
    // });
    // await this.fetchGridData();
    // this.success("提交成功");
  }

  /**
   * @description: 切换通过和驳回
   * @param {*} status
   * @return {*}
   */
  changeApprovalType(status) {
    if (status == "Return") {
      this.getBackOffData()
      this.opinionData = "有异议";
    } else {
      this.opinionData = "同意";
    }
  }
  // 查询退回步骤
  async getBackOffData(){
    let Obj:any ={}
    Obj.wfId = this.rowData.flowId
    Obj.stepId =this.rowData.wfsId
    let data:any =await this.workFlowTaskApi.getBackOffData(Obj)
    if(data.code == 200){
      this.backList = data.data
    }
  }

  /**
   * @description: 日期格式化
   * @param {*} data
   * @return {*}
   */
  getDate(data) {
    return parseInt(
      data.getFullYear() + (data.getMonth() + 1) + data.getDate()
    );
  }

  /**
   *   判断流程是否是指定审批人（提交）
   */
  async loadStepIsCustomUser(FlowId) {
    let res1 = await this.workFlowTaskApi.getNextStepIsAssign({ wfId: FlowId });
    if (res1.code == 200) {
      this.isCustomUser = res1.data;
    }
  }
  close(){
    this.approvalModal =false;
    this.$emit("on-approve",true);
  }
}
